var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.newsletters)?_c('div',[_c('ContentHeader',[_c('h1',[_vm._v("Mina nyhetsbrev")])]),_c('AreaNotifications',{attrs:{"area":"newsletters"}}),_c('h2',[_vm._v(" Jag vill ha utskick gällande ")]),_c('NewslettersForm'),_c('AppMenu',{attrs:{"extraMenuAtBottom":true}})],1):_c('PreLoader')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }